import { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button , Paper} from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import Title from "../../components/Title";
import GroupTable from "./GroupTable";
import { headerDataAdmin } from "../../data/modules/admin-header";
import { userDetailContext } from "../../App";
import { hasPrivilege } from "../../utils/privilege";
import { Redirect, useNavigate } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function GroupList(props) {
  const navigate = useNavigate();
  const contextData = useContext(userDetailContext);
  function handleClick() {
    navigate("/groups/add");
  }


  const classes = useStyles();

  return (

    <MainContainer {...headerDataAdmin}>
      <Grid container item xs={12}>
        {hasPrivilege(contextData.privileges, 'Admin-Button-Import-Group') &&
          <Button
            variant="contained"
            onClick={handleClick}
            style={{ fontWeight: 600 }}
          >
            IMPORTER
          </Button>
        }
        <Spacer x={2} />
        {hasPrivilege(contextData.privileges, 'Admin-Button-Export-Group') &&
          <Button
            variant="contained"
            onClick={handleClick}
            style={{ fontWeight: 600 }}
          >
            EXPORTER
          </Button>
        }
        <Spacer x={2} />
        {hasPrivilege(contextData.privileges, 'Admin-Group-Add') &&
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClick}
            style={{ fontWeight: 600 }}
          >
            CREER
          </Button>
        }
      </Grid>
      <Spacer y={2} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <GroupTable />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
